/* eslint @typescript-eslint/naming-convention: 0 */

import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

export interface EventParams {
  event_id: string;
  can_reserve: boolean;
  start_at: string;
  end_at: string;
}

export const buildEventParams = (experienceEvent: WabunkaExperienceEventViewModel): EventParams => {
  return {
    event_id: experienceEvent.id,
    can_reserve: experienceEvent.canReserve,
    start_at: experienceEvent.startAt.toString(),
    end_at: experienceEvent.endAt.toString(),
  };
};
